import { HttpClient } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError, map, take } from 'rxjs/operators';

export const resourceLoaderFactory =
  (http: HttpClient, blobObjectCreator: (d: any) => any) => (uri: string, httpOptions: Record<string, any>) => {
    return http.get(uri, { ...httpOptions, withCredentials: true }).pipe(
      take(1),
      catchError(error => throwError(() => error.error)),
      map(blobObjectCreator)
    );
  };
